"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle activity indicator / throbber / spinner
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.activityIndicator = {
    attach: function () {
        $('<div class="spinner spinner--body circle"></div>').appendTo('body');
        // Quick Fix: Do not attach throbber for Safari because it causes a complete freeze
        // in combination with active scriptmerger
        // ToDo: Find and resolve causation
        var agent = navigator.userAgent.toLowerCase();
        if (agent.indexOf('safari') < 0) {
            $('.spinner.circle').attachThrobber();
        }
    },
    detach: function () {
        $('.spinner.circle').fadeOut(500, function () {
            $('.spinner.circle').remove();
        });
    }
};
exports.default = {};
